var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPowerpointIcon = function SvgPowerpointIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.67334H1.5C0.675 0.67334 0 1.2913 0 2.04658V13.948C0 14.7033 0.675 15.3212 1.5 15.3212H14.5C15.325 15.3212 16 14.7033 16 13.948V2.04658C16 1.2913 15.325 0.67334 14.5 0.67334ZM14 11.4973H2V4.49728H14V11.4973Z",
    fill: "#FF9F0A"
  })));
};
export { SvgPowerpointIcon as ReactComponent };
export default __webpack_public_path__ + "powerpoint-icon.svg";